module.exports = __webpack_public_path__ + "181911e2d3f1dcb75f5f59e382a4f18f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/writing.png
// module id = 1714
// module chunks = 0